import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getMaster } from './firebase';
import {
  STATUS_IDLE,
  STATUS_FETCHING,
  STATUS_ERROR,
  STATUS_READY
} from './constants';

export const fetchShiftMaster = createAsyncThunk('fetchShiftMaster', async () => await getMaster('shifts'));

const shiftsSlice = createSlice({
  name: 'shiftMaster',
  initialState: {
    status: STATUS_IDLE,
    data: null
  },
  reducers: {},
  extraReducers (builder) {
    builder
      .addCase(fetchShiftMaster.pending, (state, action) => {
        state.status = STATUS_FETCHING
      })
      .addCase(fetchShiftMaster.fulfilled, (state, action) => {
        state.status = STATUS_READY
        state.data = action.payload
      })
      .addCase(fetchShiftMaster.rejected, (state, action) => {
        state.status = STATUS_ERROR
        state.error = action.error.message
      })
  }
})

export default shiftsSlice.reducer
